var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5001 84.7083C46.1879 84.7994 38.9512 83.2212 32.3408 80.094C27.2168 77.5938 22.6157 74.1411 18.783 69.9201C14.7234 65.5559 11.527 60.4624 9.36258 54.9088L8.91675 53.5L9.38487 52.0912C11.5508 46.5425 14.7404 41.4503 18.7875 37.08C22.6187 32.8593 27.2184 29.4066 32.3408 26.9061C38.9513 23.7789 46.1879 22.2008 53.5001 22.2917C60.8123 22.2009 68.0489 23.7791 74.6593 26.9061C79.7834 29.406 84.3847 32.8588 88.2171 37.08C92.2844 41.4382 95.4819 46.5333 97.6376 52.0912L98.0834 53.5L97.6153 54.9088C90.6211 73.1157 73.0017 85.0175 53.5001 84.7083ZM53.5001 31.2083C38.3233 30.7328 24.3935 39.5681 18.355 53.5C24.3925 67.4327 38.323 76.2685 53.5001 75.7917C68.6765 76.266 82.6057 67.431 88.6451 53.5C82.6146 39.5614 68.6796 30.7227 53.5001 31.2083ZM53.5001 66.875C47.0682 66.9176 41.5043 62.4049 40.2186 56.1027C38.9328 49.8004 42.2841 43.4689 48.2187 40.9884C54.1532 38.508 61.0134 40.5714 64.5948 45.9142C68.1763 51.2569 67.4786 58.3867 62.9295 62.9338C60.4387 65.454 57.0434 66.8731 53.5001 66.875Z",
    fill: "#242731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.cdd37d2e754d70475a51d3d34a3719fc.svg";
export { ForwardRef as ReactComponent };